<template>
  <div class="ga-footer mdl-shadow--2dp">
    <div id="container">
      <!-- ABOUT US -->
      <div id="aboutus" class="slide" v-show="showAboutus" transition="showSlide">
        <div class="content">
          <div class="big-text">
            <img src="/static/img/title_2.png" />
          </div>
          <div class="dash"></div>
          <h2>{{'master.about.title' | label}}</h2>
          <p></p>
          <div class="pwrapper" >{{{'master.about.text1.text' | label}}}</div>
          <div class="pwrapper">{{{'master.about.text2.text' | label}}}</div>
          <!-- <div class="dash"></div> -->
          <p></p>
        </div>
      </div>
      <!-- CONTACT -->
      <div id="contact" class="slide" v-show="showContact" transition="showSlide">
        <div class="content">
          <div style="float: left;">
            <div class="dash"></div>
            <h2>{{'master.contact.title' | label}}</h2>
          </div>
          <div class="contact">
            <ul>
              <li>
                <img src="/static/img/contact_1.png" alt="">
                <span class="label"><a href="{{'master.contact.link' | label}}">{{'master.contact.name' | label}}</a>&nbsp;Kaffeestrasse 16, 8180 B&uuml;lach, Conf&aelig;deratio Helvetica</span>
              </li>
              <!--<li>-->
              <!--<img src="static/contact_2.png" alt="">-->
              <!--<span class="label">{{[master.contact.phone]}}</span>-->
              <!--</li>-->
              <li>
                <img src="/static/img/contact_3.png" alt="">
                <span class="label"><a href="mailto:{{'master.contact.email' | label}}">{{'master.contact.email' | label}}</a></span>
              </li>
            </ul>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
    <!-- DICLAIMERS -->
    <div v-show="showTerms" @click="toggleTerms" class="modal-big" transition="fade">
      <br>
      <div class="mdl-dialog scrollbar">
        <div @click.stop="toggleTerms"><span class="close fas fa-times fa-sm"></span></div>
        <h3 class="mdl-dialog__title">{{{ 'register.termsAndConditions.title' | label }}}</h3>
        <div class="mdl-dialog__content">
          <p>
            {{{ 'register.termsAndConditions.text' | label }}}
          </p>
        </div>
      </div>
    </div>
    <div v-show="showPrivacy" @click="togglePrivacy" class="modal-big" transition="fade">
      <br>
      <div class="mdl-dialog scrollbar">
        <div @click.stop="togglePrivacy"><span class="close fas fa-times fa-sm"></span></div>
        <h3 class="mdl-dialog__title">{{{ 'register.privacyAndCookiesPolicy.title' | label }}}</h3>
        <div class="mdl-dialog__content">
          <p>
            {{{ 'register.privacyAndCookiesPolicy.text' | label }}}
          </p>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <footer>
      <div class="footer mdl_grid">
        <!-- <div class="mdl-typography--font-light">{{'general.application.title' | label}}</div> -->
        <ul>
          <li class="footerLink mdl-cell--2-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone" @click="toggleAbout"><span class="fas fa-user-friends"></span>&nbsp;{{{'footer.link.about' | label}}}</li>
          <li class="footerLink mdl-cell--2-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone" @click="toggleContact"><span class="fas fa-at"></span>&nbsp;{{{'footer.link.contact' | label}}}</li>
          <li class="footerLink mdl-cell--2-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone" @click="toggleTerms"><span class="fas fa-file-signature"></span>&nbsp;{{{'footer.link.terms.conditions' | label}}}</li>
          <li class="footerLink mdl-cell--2-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone" @click="togglePrivacy"><span class="fas fa-lock"></span>&nbsp;{{{'footer.link.cookies' | label}}}</li>
        </ul>
      </div>
      <div id="social">
        <!-- Facebook -->
        <a v-if="showFacebook" href="{{'master.social.facebook.url' | label}}" title="{{'master.social.facebook.link' | label}}" target="_blank" transition="bounceDown"><span class="fab fa-facebook-f fa-lg"></span></a>
        <!-- Twitter -->
        <a v-if="showTwitter" href="{{'master.social.twitter.url' | label}}" title="{{'master.social.twitter.link' | label}}" target="_blank" transition="socialHover"><span class="fab fa-twitter fa-lg"></a>
        <!-- Reddit -->
        <a v-if="showReddit" href="{{'master.social.reddit.url' | label}}" title="{{'master.social.reddit.link' | label}}" target="_blank"><span class="fab fa-reddit-alien fa-lg"></a>
        <!-- Telegram -->
        <a v-if="showTelegram" href="{{'master.social.telegram.url' | label}}" title="{{'master.social.telegram.link' | label}}" target="_blank" transition="socialHover"><span class="fab fa-telegram-plane fa-lg"></a>
        <!-- Wechat -->
        <a v-if="showWechat" href="{{'master.social.wechat.url' | label}}" title="{{'master.social.wechat.link' | label}}" target="_blank" transition="socialHover"><span class="fab fa-weixin fa-lg"></a>
        <!-- Instagram -->
        <a v-if="showInstagram" href="{{'master.social.instagram.url' | label}}" title="{{'master.social.instagram.link' | label}}" target="_blank" transition="socialHover"><span class="fab fa-instagram fa-lg"></a>
        <!-- Medium -->
        <a v-if="showMedium" href="{{'master.social.medium.url' | label}}" title="{{'master.social.medium.link' | label}}" target="_blank" transition="socialHover"><span class="fab fa-medium-m fa-lg"></a>
        <!-- Youtube -->
        <a v-if="showYoutube" href="{{'master.social.youtube.url' | label}}" title="{{'master.social.youtube.link' | label}}" target="_blank" transition="socialHover"><span class="fab fa-youtube fa-lg"></a>
        <!-- Vimeo -->
        <a v-if="showVimeo" href="{{'master.social.vimeo.url' | label}}" title="{{'master.social.vimeo.link' | label}}" target="_blank" transition="socialHover"><span class="fab fa-vimeo-v fa-lg"></a>
      </div>
      <p class="copyright">
        {{{'footer.copyright' | label}}}
      </p>
    </footer>
    <div v-if="showGDPR" class="gdpr">
      <div class="mdl-card__actions">
        <div class="card-grid mdl-grid">
          <div class="mdl-cell mdl-cell--8-col align-self-center" >
            {{{ 'general.app.gdprPolicy.text' | label}}}
          </div>
          <div class="mdl-cell mdl-cell--2-col">
            <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill" @click="togglePrivacyOnModal">{{ 'general.app.gdprPolicy.more' | label}}</div>
          </div>
          <div class="mdl-cell mdl-cell--2-col">
            <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill" @click="acceptGdprPolicy()">{{ 'general.app.gdprPolicy.accept' | label}}</div>
          </div>
        </div>
      </div>
      <modal v-if="showModal"
        header="register.privacyAndCookiesPolicy.title"
        body="register.privacyAndCookiesPolicy.text"
        footer=''
        close="general.app.dialog.close">
      </modal>
    </div>
  </div>
</template>

<script>
var cookie = require('cookie')

function scrollUp (slide) {
  // var element = getComputedStyle(document.querySelector('#' + slide))
  // 'top': element.offsetHeight
  var element = document.querySelector('#' + slide)
  element.scrollIntoView(true)
  // window.scrollTo(0, 200)
  /* window.scrollTo({
    'behavior': 'smooth',
    'left': 0,
    'top': +500
  }) */
}
module.exports = {
  ready: function () {
    window.componentHandler.upgradeAllRegistered()
    var cookies = cookie.parse(document.cookie)
    if (cookies.gdprPolicyAccepted) {
      this.showGDPR = false
    } else {
      this.showGDPR = true
    }
  },
  components: {
    modal: require('c/components/Modal')
  },
  computed: {
    showFacebook: function () {
      return (this.$interpolate("{{'master.social.facebook.url' | label}}") !== 'master.social.facebook.url')
    },
    showTwitter: function () {
      return (this.$interpolate("{{'master.social.twitter.url' | label}}") !== 'master.social.twitter.url')
    },
    showReddit: function () {
      return (this.$interpolate("{{'master.social.reddit.url' | label}}") !== 'master.social.reddit.url')
    },
    showTelegram: function () {
      return (this.$interpolate("{{'master.social.telegram.url' | label}}") !== 'master.social.telegram.url')
    },
    showWechat: function () {
      return (this.$interpolate("{{'master.social.wechat.url' | label}}") !== 'master.social.wechat.url')
    },
    showInstagram: function () {
      return (this.$interpolate("{{'master.social.instagram.url' | label}}") !== 'master.social.instagram.url')
    },
    showMedium: function () {
      return (this.$interpolate("{{'master.social.medium.url' | label}}") !== 'master.social.medium.url')
    },
    showYoutube: function () {
      return (this.$interpolate("{{'master.social.youtube.url' | label}}") !== 'master.social.youtube.url')
    },
    showVimeo: function () {
      return (this.$interpolate("{{'master.social.vimeo.url' | label}}") !== 'master.social.vimeo.url')
    }
  },
  methods: {
    toggleAbout: function () {
      this.showAboutus = !this.showAboutus
      scrollUp('aboutus')
    },
    toggleContact: function () {
      this.showContact = !this.showContact
      scrollUp('contact')
    },
    toggleTerms: function () {
      this.showTerms = !this.showTerms
    },
    togglePrivacy: function () {
      this.showPrivacy = !this.showPrivacy
    },
    togglePrivacyOnModal: function () {
      this.showModal = !this.showModal
      if (this.showModal) this.isGdprShown = true
    },
    acceptGdprPolicy: function () {
      var now = new Date()
      now.setDate(now.getDate() + 6)
      document.cookie = cookie.serialize('gdprPolicyAccepted', true) + ';Expires=' + now.toUTCString() + ';'
      this.showGDPR = false
      this.showModal = false
    }
  },
  events: {
    'closeModal': function () {
      this.showModal = false
      this.acceptGdprPolicy()
    }
  },
  data: function () {
    return {
      showAboutus: false,
      showContact: false,
      showTerms: false,
      showPrivacy: false,
      showGDPR: true,
      showModal: false,
      isGdprShown: false
    }
  }
}
</script>

<style scoped>
.mdl-mini-footer {
  display: block;
  margin-top: 0;
  border-top: 1px solid #52757a;
}
.copyright {
  margin: 0;
  font-size: 0.8em;
  padding: 1em;
  text-align: right;
}
.footer {
  position: relative;
  color: #52757a;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
}
.footer .footerLink {
  display: inline-block;
  margin: 1em 0.5em;
  cursor: pointer;
  font-weight: 600;
}
.footer .footerLink:hover {
  color: #f19100;
}
.content {
  /*max-width: 560px;*/
  max-width: 800px;
  margin: auto;
  /* padding-left: 200px; */
  z-index: 2;
}
.slide {
  position: relative;
  /*z-index: -1;*/
}
.slide .content h2 {
  margin: 0;
  padding: 0;
  border: 0;
  line-height: 1.3em;
}
.contact {
  float: left;
  margin: 2em 0;
  /* width: 80%; */
  /*width: 50%;*/
}
.contact img {
  vertical-align:middle;
  margin: 0.3em;
}
#container {
  text-align: left;
}
#aboutus {
  background-color: #fff;
  z-index: 1;
  padding-top: 2em;
  border-bottom: 1px solid #52757a
}
#aboutus .content p {
  margin: 0;
}
#aboutus .big-text {
  position: absolute;
  margin-left: -40em;
  margin-top: -6em;
}
#aboutus .big-text h1 {
  color: #d9d9d9;
}
#contact {
  background-color: #52757a;
  z-index: 1;
  padding-top: 2em;
  color: #fff;
}
#contact h2 {
  color: #fff;
}
#social {
  padding-top: 0.5em;
}
#social a {
  border-radius: 50%;
  box-shadow: none;
  padding: 0.5em;
  background-color: #52757a;
  color: white !important;
  margin-right: 0.3em;
  width: 1.3em;
  height: 1.3em;
  line-height: 2.5em;
}
#social a span {
  width: 1em;
  height: 1em;
}
#social a:hover {
  padding: 0.8em;
}
.socialHover-transition {
  transition: all .5s ;
  -webkit-transition: all .3s ease; /* For Safari 3.1 to 6.0 */
}
/* .showSlide-enter defines the starting state for entering */
/* .showSlide-leave defines the ending state for leaving */
.socialHover-enter, .socialHover-leave {
  padding: 0.5em;
  scroll-behavior: smooth;
}
.modal-big {
  margin-bottom: 15px;
}
.modal-big > .mdl-dialog{
  width: 80%;
  margin: auto;
  height: 350px;
}
.close {
  color:#52757a;
  margin: 5px 0 0 5px;
}
.gdpr {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  background-color: #52747a; 
  border-top: 2px solid #F19100;
  z-index: 1000;
  text-align: center;
  vertical-align: middle;
}
.gdpr .mdl-button--raised.mdl-button--colored {
  background-color: #d9d9d9;
  color: #52747a;
}
.align-self-center {
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?6b915190